import React, { memo, useEffect, useMemo, useRef, useState } from "react";

const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const longDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const compactWorkingDayOrder = [1, 2, 3, 4, 5, 6, 0];
const compactWorkingDayLabels = {
  0: "S",
  1: "M",
  2: "T",
  3: "W",
  4: "T",
  5: "F",
  6: "S",
};
const monthFmt = new Intl.DateTimeFormat("en-ZA", { month: "long", year: "numeric" });
const dateFmt = new Intl.DateTimeFormat("en-ZA", { year: "numeric", month: "short", day: "2-digit" });

const styles = `
.gcc-phased{--bg:#f6f8fb;--card:#fff;--ink:#1f2937;--muted:#6b7280;--line:#d9e1ec;--brand:#2563eb;--work:#e9f7ef;--non:#f3f4f6;--special:#fff1c2;--holiday:#ffe4e6;--phase:#eef2ff;--danger:#dc2626;color:var(--ink);font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}
.gcc-phased *{box-sizing:border-box}.gcc-phased .gcc-header{padding:22px 24px;background:linear-gradient(135deg,#0f172a,#1e3a8a);color:white;border-radius:14px 14px 0 0}
.gcc-phased .gcc-header h1{margin:0 0 6px;font-size:24px;letter-spacing:0}.gcc-phased .gcc-header p{margin:0;color:#dbeafe;font-size:14px;max-width:1150px;line-height:1.5}
.gcc-phased .gcc-main{display:grid;grid-template-columns:minmax(360px,470px) minmax(0,1fr);gap:18px;padding:18px;background:var(--bg);border:1px solid var(--line);border-top:0;border-radius:0 0 14px 14px}
.gcc-phased .gcc-card{background:var(--card);border:1px solid var(--line);border-radius:16px;box-shadow:0 10px 28px rgba(15,23,42,.07);padding:16px;min-width:0}
.gcc-phased h2{font-size:17px;margin:0 0 12px;letter-spacing:0}.gcc-phased h3{font-size:14px;margin:18px 0 8px;color:#374151;letter-spacing:0}
.gcc-phased label{display:block;font-size:13px;color:#374151;margin:10px 0 6px;font-weight:650;letter-spacing:0;text-transform:none}
.gcc-phased input,.gcc-phased select,.gcc-phased button{font:inherit}.gcc-phased input[type=date],.gcc-phased input[type=number],.gcc-phased input[type=text],.gcc-phased select{width:100%;padding:10px 11px;border:1px solid #cbd5e1;border-radius:10px;background:white;color:var(--ink)}
.gcc-phased .row{display:grid;grid-template-columns:1fr 1fr;gap:10px}.gcc-phased .checkline{display:flex;align-items:center;gap:9px;margin:10px 0;font-size:14px}.gcc-phased .checkline input{width:18px;height:18px}
.gcc-phased .inline-check{display:flex;align-items:center;gap:9px;margin:10px 0;font-size:13px;color:#374151;font-weight:650}.gcc-phased .inline-check input{width:18px;height:18px}
.gcc-phased .break-count-row{display:grid;grid-template-columns:minmax(0,1fr) 150px;gap:12px;align-items:end;margin-top:8px}
.gcc-phased .period-row{display:grid;grid-template-columns:1fr 1fr;gap:8px;align-items:end;margin-top:8px;padding:12px;border:1px solid var(--line);border-radius:12px;background:#fff}.gcc-phased .period-row .break-name{grid-column:1/-1}
.gcc-phased .period-row.valid{border-color:#34d399;background:#f0fdf4}.gcc-phased .period-row.invalid{border-color:#f87171;background:#fff7f7}.gcc-phased .period-row.short{border-color:#fbbf24;background:#fffbeb}
.gcc-phased .period-status{grid-column:1/-1;margin-top:2px;font-size:12px;line-height:1.4}.gcc-phased .period-status.valid{color:#166534}.gcc-phased .period-status.invalid{color:#b91c1c}.gcc-phased .period-status.short{color:#92400e}.gcc-phased .period-status.pending{color:var(--muted)}
.gcc-phased .weekday-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:6px;margin-top:8px}.gcc-phased .weekday-grid label{margin:0;padding:8px 4px;text-align:center;border:1px solid var(--line);border-radius:10px;font-size:11px;background:#f8fafc;cursor:pointer;user-select:none}
.gcc-phased .weekday-grid input{display:none}.gcc-phased .weekday-grid label.checked{background:var(--work);border-color:#86efac;color:#166534}
.gcc-phased .working-day-panel{margin:12px 0 4px;padding:10px;border:1px solid var(--line);border-radius:12px;background:#f8fafc}.gcc-phased .working-day-head{display:flex;justify-content:space-between;gap:10px;align-items:baseline;margin-bottom:8px}.gcc-phased .working-day-head strong{font-size:13px}.gcc-phased .working-day-head span{font-size:11px;color:var(--muted);text-align:right}.gcc-phased .compact-weekday-grid{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:6px}.gcc-phased .compact-weekday-grid label{margin:0;min-width:0;padding:7px 0;border:1px solid var(--line);border-radius:999px;background:white;color:#64748b;font-size:12px;font-weight:800;text-align:center;cursor:pointer;user-select:none}.gcc-phased .compact-weekday-grid input{display:none}.gcc-phased .compact-weekday-grid label.checked{background:#dcfce7;border-color:#22c55e;color:#166534}
.gcc-phased .btns{display:flex;gap:8px;flex-wrap:wrap;margin-top:14px}.gcc-phased button{border:0;border-radius:10px;padding:10px 12px;cursor:pointer;color:white;background:var(--brand);font-weight:700}.gcc-phased button.secondary{background:#475569}.gcc-phased button.danger{background:var(--danger)}.gcc-phased button.ghost{background:white;color:#334155;border:1px solid #cbd5e1}.gcc-phased button:hover{filter:brightness(.97)}
.gcc-phased .phase-card{border:1px solid var(--line);border-radius:14px;padding:12px;background:#fbfdff;margin-top:12px}.gcc-phased .phase-card.active{outline:3px solid #93c5fd;background:var(--phase)}.gcc-phased .phase-head{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:8px}.gcc-phased .phase-title{font-weight:800;font-size:14px}.gcc-phased .mini{padding:7px 9px;font-size:12px;border-radius:9px}
.gcc-phased .phase-result{margin-top:10px;display:grid;grid-template-columns:repeat(2,1fr);gap:8px;font-size:12px}.gcc-phased .phase-result div{background:white;border:1px solid var(--line);border-radius:10px;padding:8px}.gcc-phased .phase-result small{display:block;color:var(--muted)}
.gcc-phased .summary{display:grid;grid-template-columns:repeat(auto-fit,minmax(135px,1fr));gap:10px;margin-bottom:14px}.gcc-phased .metric{border:1px solid var(--line);border-radius:14px;padding:12px;background:#f8fafc;min-width:0}.gcc-phased .metric small{display:block;color:var(--muted);font-size:12px;margin-bottom:4px}.gcc-phased .metric strong{display:block;font-size:17px;overflow-wrap:anywhere}
.gcc-phased .calendar-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px}.gcc-phased .month-title{font-size:20px;font-weight:800}.gcc-phased .calendar{display:grid;grid-template-columns:repeat(7,1fr);gap:6px}.gcc-phased .dow{color:var(--muted);font-weight:750;font-size:12px;text-align:center;padding:4px}.gcc-phased .day{min-height:94px;border:1px solid var(--line);border-radius:12px;background:white;padding:8px;cursor:pointer;position:relative;overflow:hidden;color:var(--ink);text-align:left;font-weight:400}.gcc-phased .day:hover{outline:2px solid #93c5fd}.gcc-phased .day.out{opacity:.35;background:#f8fafc}.gcc-phased .day.work{background:var(--work)}.gcc-phased .day.non{background:var(--non)}.gcc-phased .day.special{background:var(--special);border-color:#fbbf24}.gcc-phased .day.buildersBreak{background:#ffedd5;border-color:#f97316}.gcc-phased .day.publicHoliday{background:var(--holiday);border-color:#fda4af}.gcc-phased .day.counted{box-shadow:inset 0 0 0 3px #60a5fa}.gcc-phased .day.due{box-shadow:inset 0 0 0 4px #16a34a}.gcc-phased .day.start{box-shadow:inset 0 0 0 4px #111827}.gcc-phased .num{font-weight:800;font-size:14px}
.gcc-phased .tag{display:inline-block;font-size:10px;padding:2px 6px;border-radius:999px;margin:4px 3px 0 0;background:rgba(255,255,255,.78);border:1px solid rgba(15,23,42,.12)}.gcc-phased .phase-chip{background:#eef2ff;color:#3730a3;border-color:#c7d2fe}.gcc-phased .bb-wd-badge{position:absolute;top:6px;right:6px;background:#dc2626;color:white;border-radius:5px;padding:2px 5px;font-size:10px;font-weight:850;letter-spacing:.01em;line-height:1;box-shadow:0 1px 3px rgba(127,29,29,.25)}.gcc-phased .reason{font-size:11px;color:#4b5563;margin-top:4px;line-height:1.2;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}
.gcc-phased .legend{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0 0;font-size:12px;color:#374151}.gcc-phased .legend span{display:inline-flex;align-items:center;gap:5px}.gcc-phased .swatch{width:14px;height:14px;border:1px solid var(--line);border-radius:4px;display:inline-block}.gcc-phased .notes{margin-top:14px;padding:12px;background:#f8fafc;border:1px solid var(--line);border-radius:12px;color:#475569;font-size:13px;line-height:1.45}.gcc-phased .table-wrap{max-height:300px;overflow:auto;border:1px solid var(--line);border-radius:12px;margin-top:12px}.gcc-phased table{width:100%;border-collapse:collapse;font-size:12px}.gcc-phased th,.gcc-phased td{border-bottom:1px solid var(--line);padding:8px;text-align:left;vertical-align:top}.gcc-phased th{position:sticky;top:0;background:#f8fafc;z-index:1}.gcc-phased .muted{color:var(--muted)}
@media(max-width:1100px){.gcc-phased .gcc-main{grid-template-columns:1fr}.gcc-phased .summary{grid-template-columns:repeat(2,1fr)}.gcc-phased .day{min-height:78px}}
@media(max-width:600px){.gcc-phased .gcc-header{padding:18px}.gcc-phased .gcc-main{padding:10px}.gcc-phased .break-count-row,.gcc-phased .period-row,.gcc-phased .row{grid-template-columns:1fr}.gcc-phased .period-row .break-name{grid-column:auto}.gcc-phased .summary{grid-template-columns:1fr 1fr}.gcc-phased .calendar{gap:3px}.gcc-phased .calendar>*{min-width:0}.gcc-phased .day{min-width:0;min-height:68px;padding:4px}.gcc-phased .day .tag{display:block;max-width:100%;padding:1px 3px;font-size:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.gcc-phased .bb-wd-badge{top:3px;right:3px;padding:1px 3px;font-size:8px}.gcc-phased .reason{font-size:9px}.gcc-phased .calendar-head{gap:6px}.gcc-phased .month-title{font-size:16px}.gcc-phased .calendar-head button{padding:8px}.gcc-phased .phase-head{align-items:flex-start;flex-direction:column}}
`;

function iso(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function fromIso(value) {
  const [year, month, day] = String(value || "").split("-").map(Number);
  return new Date(year || new Date().getFullYear(), (month || 1) - 1, day || 1);
}

function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function addMonths(date, months) {
  const next = new Date(date);
  const originalDay = next.getDate();
  next.setDate(1);
  next.setMonth(next.getMonth() + months);
  const lastDay = new Date(next.getFullYear(), next.getMonth() + 1, 0).getDate();
  next.setDate(Math.min(originalDay, lastDay));
  return next;
}

function monthsToCalendarDays(start, months) {
  return Math.max(1, Math.round((addMonths(start, months) - start) / 86400000));
}

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function sameDate(a, b) {
  return a && b && iso(a) === iso(b);
}

function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function observedSouthAfricaHolidays(year) {
  const fixed = [
    ["01-01", "New Year's Day"],
    ["03-21", "Human Rights Day"],
    ["04-27", "Freedom Day"],
    ["05-01", "Workers' Day"],
    ["06-16", "Youth Day"],
    ["08-09", "National Women's Day"],
    ["09-24", "Heritage Day"],
    ["12-16", "Day of Reconciliation"],
    ["12-25", "Christmas Day"],
    ["12-26", "Day of Goodwill"],
  ];
  const out = {};
  fixed.forEach(([monthDay, name]) => {
    const [month, day] = monthDay.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    out[iso(date)] = name;
    if (date.getDay() === 0) out[iso(addDays(date, 1))] = `${name} observed`;
  });
  const easter = easterSunday(year);
  out[iso(addDays(easter, -2))] = "Good Friday";
  out[iso(addDays(easter, 1))] = "Family Day";
  if (year === 2022) {
    out["2022-12-27"] = "Public holiday declared for Christmas Day overlap";
  }
  return out;
}

function holidayMapFor(country, phases = []) {
  const years = new Set();
  phases.forEach((phase) => {
    const year = fromIso(phase.commencement || phase.displayCommencement).getFullYear();
    for (let offset = -1; offset <= 12; offset += 1) years.add(year + offset);
  });
  if (!years.size) {
    const year = new Date().getFullYear();
    for (let offset = -1; offset <= 12; offset += 1) years.add(year + offset);
  }
  const out = {};
  if (country === "ZA") {
    years.forEach((year) => Object.assign(out, observedSouthAfricaHolidays(year)));
  }
  return out;
}

function defaultWeekdays() {
  return [false, true, true, true, true, true, true];
}

function createPhase(seed = {}, index = 1) {
  const today = iso(new Date());
  return {
    id: seed.id || `phase_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    name: seed.name || `Phase ${index}`,
    commencement: seed.commencement || today,
    duration: Number(seed.duration || 156),
    durationType: seed.durationType || "weeks",
    weekdays: Array.isArray(seed.weekdays) ? seed.weekdays : defaultWeekdays(),
    linkedToPrevious: seed.linkedToPrevious === true,
  };
}

function resultLabel(date) {
  return date ? dateFmt.format(date) : "-";
}

function durationLabel(phase) {
  if (!phase) return "";
  if (phase.durationType === "weeks") return `${phase.duration} weeks`;
  if (phase.durationType === "months") return `${phase.duration} months`;
  if (phase.durationType === "workingWeeks") return `${phase.duration} working weeks`;
  if (phase.durationType === "workingDays") return `${phase.duration} working days`;
  return `${phase.duration} calendar days`;
}

function dateInSpecialPeriod(date, specialPeriods = []) {
  const key = iso(date);
  const match = specialPeriods.find((period) => (
    period?.startDate &&
    period?.endDate &&
    key >= period.startDate &&
    key <= period.endDate
  ));
  return match || null;
}

export function countBuildersBreakWorkingDays(period, holidays = {}) {
  if (!period?.startDate || !period?.endDate) return null;
  const start = fromIso(period.startDate);
  const end = fromIso(period.endDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return null;

  let workingDays = 0;
  for (let date = new Date(start); date <= end; date = addDays(date, 1)) {
    const weekday = date.getDay();
    if (weekday !== 0 && !holidays[iso(date)]) workingDays += 1;
  }
  return workingDays;
}

export function buildBuildersBreakWorkingDayLabels(periods = [], holidays = {}) {
  const labels = {};
  periods.forEach((period) => {
    if (!period?.startDate || !period?.endDate) return;
    const start = fromIso(period.startDate);
    const end = fromIso(period.endDate);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return;

    let workingDay = 0;
    for (let date = new Date(start); date <= end; date = addDays(date, 1)) {
      const weekday = date.getDay();
      const key = iso(date);
      if (weekday === 0 || holidays[key]) continue;
      workingDay += 1;
      if (!labels[key]) {
        labels[key] = {
          periodId: period.id,
          dayNumber: workingDay,
          label: `BB WD ${String(workingDay).padStart(2, "0")}`,
        };
      }
    }
  });
  return labels;
}

export function validateBuildersBreak(period, holidays = {}) {
  if (!period?.startDate || !period?.endDate) {
    return {
      status: "pending",
      valid: false,
      workingDays: null,
      message: "Enter both the first and last non-working dates.",
    };
  }

  const start = fromIso(period.startDate);
  const end = fromIso(period.endDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
    return {
      status: "invalid",
      valid: false,
      workingDays: null,
      message: "The end date must be on or after the start date.",
    };
  }

  const startIsOrdinaryNonWorkingDay = start.getDay() === 0 && !holidays[iso(start)];
  if (startIsOrdinaryNonWorkingDay) {
    return {
      status: "invalid",
      valid: false,
      workingDays: countBuildersBreakWorkingDays(period, holidays),
      message: "The start date is an ordinary non-working Sunday. Start the builders' break on the first contractual special non-working date instead.",
    };
  }

  const workingDays = countBuildersBreakWorkingDays(period, holidays);
  if (workingDays > 15) {
    return {
      status: "invalid",
      valid: false,
      workingDays,
      message: `This period contains ${workingDays} working days; the contractor is entitled to 15 working days. Shorten the break to 15 or fewer working days.`,
    };
  }
  if (workingDays < 15) {
    return {
      status: "short",
      valid: true,
      workingDays,
      message: `This break contains ${workingDays} working day${workingDays === 1 ? "" : "s"} and is excluded from the time-span. Note: the contractor is entitled to 15 working days.`,
    };
  }
  return {
    status: "valid",
    valid: true,
    workingDays,
    message: "Valid builders' break: exactly 15 working days are excluded.",
  };
}

function calculatePhase(phase, holidays, skipPublic, overrides, specialPeriods = []) {
  const workingWeekdays = new Set();
  phase.weekdays.forEach((checked, index) => {
    if (checked) workingWeekdays.add(index);
  });
  const start = fromIso(phase.commencement);
  const required = Math.max(
    1,
    phase.durationType === "weeks"
      ? Math.round(Number(phase.duration || 1) * 7)
      : phase.durationType === "months"
      ? monthsToCalendarDays(start, Number(phase.duration || 1))
      : phase.durationType === "workingWeeks"
      ? Math.round(Number(phase.duration || 1) * workingWeekdays.size)
      : Number(phase.duration || 1)
  );
  const mode =
    phase.durationType === "calendarDays" || phase.durationType === "weeks" || phase.durationType === "months"
      ? "calendarDays"
      : "working";
  const counted = [];
  let excluded = 0;
  let due = new Date(start);
  let cursor = new Date(start);
  let guard = 0;

  const dayStatus = (date) => {
    const key = iso(date);
    const override = overrides[key];
    const specialPeriod = dateInSpecialPeriod(date, specialPeriods);
    const holidayName = holidays[key];
    const isHoliday = !!holidayName;
    const defaultWorking = workingWeekdays.has(date.getDay());
    if (override === "working") return { counts: true, cls: "work", label: "Working override", reason: "" };
    if (override === "special") return { counts: false, cls: "special", label: "Special non-working", reason: "Special non-working day" };
    if (specialPeriod) return { counts: false, cls: "buildersBreak", label: "Builders' break", reason: specialPeriod.name || "Builders' break" };
    if (isHoliday && skipPublic) return { counts: false, cls: "publicHoliday", label: "Public holiday", reason: holidayName };
    if (mode === "calendarDays") {
      if (override === "non") return { counts: true, cls: "non", label: "Calendar day", reason: "Manual non-working day included" };
      if (defaultWorking) return { counts: true, cls: "work", label: "Calendar day", reason: isHoliday ? holidayName : "Working weekday included" };
      return { counts: true, cls: "non", label: "Calendar day", reason: "Default non-working weekday included" };
    }
    if (override === "non") return { counts: false, cls: "non", label: "Non-working override", reason: "Manual non-working day" };
    if (defaultWorking) return { counts: true, cls: "work", label: "Working day", reason: isHoliday ? holidayName : "" };
    return { counts: false, cls: "non", label: "Non-working day", reason: "Default non-working weekday" };
  };

  while (counted.length < required && guard < 10000) {
    cursor = addDays(cursor, 1);
    const status = dayStatus(cursor);
    if (status.counts) counted.push({ date: new Date(cursor), status });
    else excluded += 1;
    due = new Date(cursor);
    guard += 1;
  }

  return {
    start,
    due,
    required,
    counted,
    excluded,
    span: Math.round((due - start) / 86400000) + 1,
    mode,
    dayStatus,
  };
}

function calculateSequentialPhases(phases = [], holidays = {}, skipPublic = true, overrides = {}, specialPeriods = []) {
  const results = {};
  const effectivePhases = [];
  phases.forEach((phase, index) => {
    const previousResult = index > 0 ? results[phases[index - 1].id] : null;
    const linkedCommencement =
      phase.linkedToPrevious && previousResult
        ? iso(previousResult.due)
        : phase.commencement;
    const displayCommencement =
      phase.linkedToPrevious && previousResult
        ? iso(addDays(previousResult.due, 1))
        : linkedCommencement;
    const effectivePhase = {
      ...phase,
      commencement: linkedCommencement,
      displayCommencement,
    };
    effectivePhases.push(effectivePhase);
    results[phase.id] = calculatePhase(effectivePhase, holidays, skipPublic, overrides, specialPeriods);
  });
  return { results, effectivePhases };
}

export function buildGccPhasedScheduleSummary(project = {}) {
  const persisted = project?.dueCompletionPhased || {};
  if (!Array.isArray(persisted.phases) || persisted.phases.length === 0) return null;

  const phases = persisted.phases.map((phase, index) => createPhase(phase, index + 1));
  const country = persisted.country || "ZA";
  const skipPublic = persisted.skipPublic !== false;
  const overrides = persisted.overrides || {};
  const specialPeriods = Array.isArray(persisted.specialPeriods) ? persisted.specialPeriods : [];
  const holidays = holidayMapFor(country, phases);
  const validSpecialPeriods = specialPeriods.filter((period) => validateBuildersBreak(period, holidays).valid);
  const { results, effectivePhases } = calculateSequentialPhases(
    phases,
    holidays,
    skipPublic,
    overrides,
    validSpecialPeriods
  );

  const rows = effectivePhases.map((phase, index) => {
    const result = results[phase.id];
    const storedPhase = phases[index] || phase;
    return {
      id: phase.id,
      name: phase.name,
      commencement: phase.commencement,
      displayCommencement: phase.displayCommencement || phase.commencement,
      linkedToPrevious: storedPhase.linkedToPrevious === true,
      durationLabel: durationLabel(phase),
      dueDate: result ? iso(result.due) : "",
      dueDateDisplay: result ? resultLabel(result.due) : "-",
      required: result?.required || 0,
      excluded: result?.excluded || 0,
      span: result?.span || 0,
      mode: result?.mode || "",
    };
  });

  const validStarts = rows.map((row) => row.displayCommencement).filter(Boolean).sort();
  const validDueDates = rows.map((row) => row.dueDate).filter(Boolean).sort();
  const activePhaseId = persisted.activePhaseId || rows[0]?.id;
  const activePhase = rows.find((row) => row.id === activePhaseId) || rows[0] || null;
  const combinedDurationLabel = rows.map((row) => row.durationLabel).filter(Boolean).join(" + ");

  return {
    country,
    skipPublic,
    phaseCount: rows.length,
    hasMultiplePhases: rows.length > 1,
    phases: rows,
    activePhase,
    earliestStart: validStarts[0] || project?.startDate || "",
    finalDueDate: validDueDates[validDueDates.length - 1] || "",
    activeDueDate: activePhase?.dueDate || "",
    combinedDurationLabel,
  };
}

function serialiseState({ country, skipPublic, clickMode, overrides, phases, activePhaseId }) {
  return {
    country,
    skipPublic,
    clickMode,
    overrides,
    activePhaseId,
    phases: phases.map((phase) => ({
      id: phase.id,
      name: phase.name,
      commencement: phase.commencement,
      duration: Number(phase.duration || 1),
      durationType: phase.durationType,
      weekdays: phase.weekdays,
      linkedToPrevious: phase.linkedToPrevious === true,
    })),
  };
}

function GccDueCompletionPhasedSection({ projectForm = {}, onScheduleChange }) {
  const persisted = projectForm.dueCompletionPhased || {};
  const initialPhases = Array.isArray(persisted.phases) && persisted.phases.length
    ? persisted.phases.map((phase, index) => createPhase(phase, index + 1))
    : [
        createPhase({
          name: "Overall Contract",
          commencement: projectForm.startDate || iso(new Date()),
          duration: Number(projectForm.contractDurationDays || 156),
          durationType: projectForm.contractDurationDays ? "calendarDays" : "weeks",
        }, 1),
      ];

  const [country, setCountry] = useState(persisted.country || "ZA");
  const [skipPublic, setSkipPublic] = useState(persisted.skipPublic !== false);
  const [clickMode, setClickMode] = useState(persisted.clickMode || "cycle");
  const [overrides, setOverrides] = useState(persisted.overrides || {});
  const [specialPeriods, setSpecialPeriods] = useState(Array.isArray(persisted.specialPeriods) ? persisted.specialPeriods : []);
  const [phases, setPhases] = useState(initialPhases);
  const [activePhaseId, setActivePhaseId] = useState(persisted.activePhaseId || initialPhases[0]?.id);
  const [visibleMonth, setVisibleMonth] = useState(startOfMonth(fromIso(initialPhases[0]?.commencement || projectForm.startDate || iso(new Date()))));
  const lastScheduleKey = useRef("");

  const holidays = useMemo(() => holidayMapFor(country, phases), [country, phases]);
  const breakValidations = useMemo(() => specialPeriods.map((period) => ({
    id: period.id,
    ...validateBuildersBreak(period, holidays),
  })), [specialPeriods, holidays]);
  const validSpecialPeriods = useMemo(() => specialPeriods.filter((period) => (
    validateBuildersBreak(period, holidays).valid
  )), [specialPeriods, holidays]);
  const buildersBreakWorkingDayLabels = useMemo(() => (
    buildBuildersBreakWorkingDayLabels(validSpecialPeriods, holidays)
  ), [validSpecialPeriods, holidays]);
  const invalidBreakCount = breakValidations.filter((validation) => validation.status === "invalid").length;
  const pendingBreakCount = breakValidations.filter((validation) => validation.status === "pending").length;

  const calculatedPhases = useMemo(() => {
    return calculateSequentialPhases(phases, holidays, skipPublic, overrides, validSpecialPeriods);
  }, [phases, holidays, skipPublic, overrides, validSpecialPeriods]);
  const phaseResults = calculatedPhases.results;
  const effectivePhases = calculatedPhases.effectivePhases;

  const activePhase = effectivePhases.find((phase) => phase.id === activePhaseId) || effectivePhases[0];
  const activeResult = activePhase ? phaseResults[activePhase.id] : null;
  const phaseRows = useMemo(() => effectivePhases.map((phase) => {
    const result = phaseResults[phase.id];
    return {
      id: phase.id,
      name: phase.name,
      displayCommencement: phase.displayCommencement || phase.commencement,
      durationLabel: durationLabel(phase),
      dueDate: result ? iso(result.due) : "",
      required: result?.required || 0,
      excluded: result?.excluded || 0,
      span: result?.span || 0,
    };
  }), [effectivePhases, phaseResults]);
  const finalDueDate = useMemo(() => (
    phaseRows.map((phase) => phase.dueDate).filter(Boolean).sort().pop() || ""
  ), [phaseRows]);
  const earliestStart = useMemo(() => (
    phaseRows.map((phase) => phase.displayCommencement).filter(Boolean).sort()[0] || ""
  ), [phaseRows]);
  const combinedDurationLabel = useMemo(() => (
    phaseRows.map((phase) => phase.durationLabel).filter(Boolean).join(" + ")
  ), [phaseRows]);
  const persistedState = useMemo(
    () => ({
      ...serialiseState({ country, skipPublic, clickMode, overrides, phases, activePhaseId: activePhase?.id || activePhaseId }),
      specialPeriods,
    }),
    [country, skipPublic, clickMode, overrides, phases, activePhase, activePhaseId, specialPeriods]
  );

  useEffect(() => {
    if (!activePhase || !activeResult || !onScheduleChange) return;
    const activeDueDate = iso(activeResult.due);
    const dueDate = finalDueDate || activeDueDate;
    const durationSummary = phaseRows.length > 1
      ? `${phaseRows.length} phases · ${combinedDurationLabel}`
      : durationLabel(activePhase);
    const nextKey = JSON.stringify({
      phaseId: activePhase.id,
      commencement: activePhase.commencement,
      dueDate,
      activeDueDate,
      finalDueDate,
      durationLabel: durationSummary,
      state: persistedState,
    });
    if (nextKey === lastScheduleKey.current) return;
    lastScheduleKey.current = nextKey;
    onScheduleChange({
      dueDate,
      activeDueDate,
      finalDueDate,
      commencementDate: earliestStart || activePhase.displayCommencement || activePhase.commencement,
      activePhaseCommencementDate: activePhase.displayCommencement || activePhase.commencement,
      contractDurationLabel: durationSummary,
      contractDurationValue: Number(activePhase.duration || 1),
      contractDurationUnit: activePhase.durationType,
      requiredCount: activeResult.required,
      activePhaseId: activePhase.id,
      phaseDateRows: phaseRows,
      dueCompletionPhased: persistedState,
    });
  }, [activePhase, activeResult, onScheduleChange, persistedState, finalDueDate, earliestStart, combinedDurationLabel, phaseRows]);

  const setPhase = (phaseId, patch) => {
    setPhases((prev) => prev.map((phase) => (
      phase.id === phaseId ? { ...phase, ...patch } : phase
    )));
  };

  const toggleWeekday = (phaseId, dayIndex, checked) => {
    setPhases((prev) => prev.map((phase) => {
      if (phase.id !== phaseId) return phase;
      const weekdays = [...phase.weekdays];
      weekdays[dayIndex] = checked;
      return { ...phase, weekdays };
    }));
  };

  const createBuildersBreak = (index) => ({
    id: `builders_break_${Date.now()}_${index}_${Math.random().toString(16).slice(2)}`,
    name: `Builders' break ${index + 1}`,
    startDate: "",
    endDate: "",
  });

  const setBuildersBreakCount = (value) => {
    const count = Math.max(0, Math.min(20, Number(value) || 0));
    setSpecialPeriods((prev) => Array.from(
      { length: count },
      (_, index) => prev[index] || createBuildersBreak(index)
    ));
  };

  const updateSpecialPeriod = (periodId, patch) => {
    setSpecialPeriods((prev) => prev.map((period) => (
      period.id === periodId ? { ...period, ...patch } : period
    )));
  };

  const addPhase = (seed = {}) => {
    const last = phases[phases.length - 1] || {};
    const lastResult = last.id ? phaseResults[last.id] : null;
    const linkedStart = lastResult ? iso(addDays(lastResult.due, 1)) : last.commencement;
    const next = createPhase({
      name: seed.name || `Phase ${phases.length + 1}`,
      commencement: seed.commencement || (seed.linkedToPrevious ? linkedStart : last.commencement) || iso(new Date()),
      duration: seed.duration || last.duration || 156,
      durationType: seed.durationType || last.durationType || "weeks",
      weekdays: seed.weekdays || (last.weekdays ? [...last.weekdays] : defaultWeekdays()),
      linkedToPrevious: seed.linkedToPrevious === true,
    }, phases.length + 1);
    setPhases((prev) => [...prev, next]);
    setActivePhaseId(next.id);
    setVisibleMonth(startOfMonth(fromIso(next.commencement)));
  };

  const duplicatePhase = (phase) => addPhase({
    name: `${phase.name} copy`,
    commencement: phase.commencement,
    duration: phase.duration,
    durationType: phase.durationType,
    weekdays: [...phase.weekdays],
    linkedToPrevious: false,
  });

  const removePhase = (phaseId) => {
    setPhases((prev) => {
      const next = prev.filter((phase) => phase.id !== phaseId);
      if (activePhaseId === phaseId && next[0]) {
        setActivePhaseId(next[0].id);
        setVisibleMonth(startOfMonth(fromIso(next[0].commencement)));
      }
      return next.length ? next : prev;
    });
  };

  const applyClickMode = (key) => {
    setOverrides((prev) => {
      const next = { ...prev };
      if (clickMode === "clear") {
        delete next[key];
        return next;
      }
      if (clickMode !== "cycle") {
        next[key] = clickMode;
        return next;
      }
      const current = next[key] || "default";
      const cycle = { default: "non", non: "special", special: "working", working: "default" };
      const nextValue = cycle[current];
      if (nextValue === "default") delete next[key];
      else next[key] = nextValue;
      return next;
    });
  };

  const renderCalendarDays = () => {
    if (!activePhase || !activeResult) return null;
    const first = startOfMonth(visibleMonth);
    const last = endOfMonth(visibleMonth);
    const gridStart = addDays(first, -first.getDay());
    const gridEnd = addDays(last, 6 - last.getDay());
    const countedSet = new Set(activeResult.counted.map((row) => iso(row.date)));
    const cells = [];
    for (let date = new Date(gridStart); date <= gridEnd; date = addDays(date, 1)) {
      const key = iso(date);
      const status = activeResult.dayStatus(date);
      const buildersBreak = validSpecialPeriods.find((period) => (
        period.startDate && period.endDate && key >= period.startDate && key <= period.endDate
      ));
      const buildersBreakWorkingDay = buildersBreakWorkingDayLabels[key];
      const duePhases = effectivePhases
        .filter((phase) => phaseResults[phase.id] && sameDate(date, phaseResults[phase.id].due))
        .map((phase) => phase.name);
      const classNames = [
        "day",
        status.cls,
        date.getMonth() !== visibleMonth.getMonth() ? "out" : "",
        countedSet.has(key) ? "counted" : "",
        sameDate(date, activeResult.due) ? "due" : "",
        sameDate(date, activeResult.start) ? "start" : "",
      ].filter(Boolean).join(" ");
      cells.push(
        <button
          key={key}
          type="button"
          className={classNames}
          title={`${key}: ${status.label}${status.reason ? ` - ${status.reason}` : ""}${buildersBreakWorkingDay ? ` (${buildersBreakWorkingDay.label})` : ""}`}
          onClick={() => applyClickMode(key)}
        >
          <div className="num">{date.getDate()}</div>
          {buildersBreakWorkingDay && <span className="bb-wd-badge">{buildersBreakWorkingDay.label}</span>}
          {overrides[key] && <span className="tag">{overrides[key]}</span>}
          {buildersBreak && <span className="tag">builders' break</span>}
          {!buildersBreak && holidays[key] && <span className="tag">holiday</span>}
          {countedSet.has(key) && <span className="tag">counted</span>}
          {sameDate(date, activeResult.due) && <span className="tag">active due</span>}
          {sameDate(date, activeResult.start) && <span className="tag">start</span>}
          {duePhases.length > 0 && !sameDate(date, activeResult.due) && <span className="tag phase-chip">phase due</span>}
          <div className="reason">{duePhases.length ? `Due: ${duePhases.join(", ")}` : (status.reason || status.label)}</div>
        </button>
      );
    }
    return cells;
  };

  return (
    <div className="gcc-phased">
      <style>{styles}</style>
      <div className="gcc-header">
        <h1>GCC 2015 Due Completion Date Calculator - Multiple Phases</h1>
        <p>Handles a whole contract or multiple sectional / phased completion dates. Each phase has its own commencement date, duration, calculation unit and working-week pattern, while sharing special non-working days and optional public holidays.</p>
      </div>
      <div className="gcc-main">
        <section className="gcc-card">
          <h2>Global Calendar Rules</h2>
          <label htmlFor="gcc-country">Country public holidays</label>
          <select id="gcc-country" value={country} onChange={(event) => setCountry(event.target.value)}>
            <option value="ZA">South Africa</option>
          </select>
          <label className="checkline">
            <input type="checkbox" checked={skipPublic} onChange={(event) => setSkipPublic(event.target.checked)} />
            <span>Skip public holidays</span>
          </label>

          <h3>Calendar click mode</h3>
          <select value={clickMode} onChange={(event) => setClickMode(event.target.value)}>
            <option value="cycle">Cycle selected date: default - non-working - special - working</option>
            <option value="working">Set selected date as working day</option>
            <option value="non">Set selected date as non-working day</option>
            <option value="special">Set selected date as special non-working day</option>
            <option value="clear">Clear override on selected date</option>
          </select>
          <div className="working-day-panel">
            <div className="working-day-head">
              <strong>Active phase working days</strong>
              <span>{activePhase?.name || "Select a phase"}</span>
            </div>
            <div className="compact-weekday-grid" aria-label="Active phase working days">
              {compactWorkingDayOrder.map((dayIndex) => (
                <label
                  key={dayIndex}
                  className={activePhase?.weekdays?.[dayIndex] ? "checked" : ""}
                  title={`${longDayNames[dayIndex]} ${activePhase?.weekdays?.[dayIndex] ? "counts as working" : "is non-working"}`}
                >
                  <input
                    type="checkbox"
                    checked={activePhase?.weekdays?.[dayIndex] || false}
                    disabled={!activePhase}
                    onChange={(event) => activePhase && toggleWeekday(activePhase.id, dayIndex, event.target.checked)}
                  />
                  {compactWorkingDayLabels[dayIndex]}
                </label>
              ))}
            </div>
          </div>
          <div className="btns">
            <button type="button" onClick={() => addPhase()}>Add phase</button>
            <button type="button" onClick={() => addPhase({ linkedToPrevious: true })}>Add linked phase</button>
            <button type="button" className="secondary" onClick={() => setPhases((prev) => [...prev])}>Recalculate all</button>
            <button type="button" className="ghost" onClick={() => activePhase && setVisibleMonth(startOfMonth(fromIso(activePhase.commencement)))}>Jump to active phase</button>
            <button type="button" className="ghost" onClick={() => setOverrides({})}>Clear date overrides</button>
          </div>
          <div className="notes">
            <strong>Calendar-day rule used here:</strong><br />
            GCC Contract Data weeks are counted as calendar weeks, including ordinary non-working weekdays. Public holidays and validated builders' breaks are excluded from the time-span.
          </div>

          <h3>Builders' breaks</h3>
          <div className="break-count-row">
            <div>
              <label htmlFor="builders-break-count">Number of builders' breaks</label>
              <div className="muted">Each break may contain up to 15 working days. Sundays and South African public holidays are excluded; Saturdays count unless they are public holidays.</div>
            </div>
            <input
              id="builders-break-count"
              type="number"
              min="0"
              max="20"
              value={specialPeriods.length}
              onChange={(event) => setBuildersBreakCount(event.target.value)}
            />
          </div>
          {specialPeriods.map((period, index) => {
            const validation = breakValidations.find((item) => item.id === period.id)
              || validateBuildersBreak(period, holidays);
            return (
            <div className={`period-row ${validation.status}`} key={period.id}>
              <div className="break-name">
                <label>Break name</label>
                <input
                  type="text"
                  value={period.name || `Builders' break ${index + 1}`}
                  onChange={(event) => updateSpecialPeriod(period.id, { name: event.target.value })}
                />
              </div>
              <div>
                <label>First non-working date</label>
                <input
                  type="date"
                  value={period.startDate || ""}
                  onChange={(event) => updateSpecialPeriod(period.id, { startDate: event.target.value })}
                />
              </div>
              <div>
                <label>Last non-working date</label>
                <input
                  type="date"
                  value={period.endDate || ""}
                  onChange={(event) => updateSpecialPeriod(period.id, { endDate: event.target.value })}
                />
              </div>
              <div className={`period-status ${validation.status}`}>{validation.message}</div>
            </div>
          );})}
          {(invalidBreakCount > 0 || pendingBreakCount > 0) && (
            <div className="notes" style={{ borderColor: invalidBreakCount ? "#f87171" : "var(--line)" }}>
              <strong>Builders' break check:</strong><br />
              {invalidBreakCount > 0
                ? `${invalidBreakCount} break${invalidBreakCount === 1 ? " is" : "s are"} not included in the due-date calculation. The contractor is entitled to a builders' break of 15 working days — a break may not exceed 15.`
                : `${pendingBreakCount} break${pendingBreakCount === 1 ? " still needs" : "s still need"} start and end dates.`}
            </div>
          )}

          <h2 style={{ marginTop: 18 }}>Phases / Sections</h2>
          {phases.map((phase) => {
            const result = phaseResults[phase.id];
            const effectivePhase = effectivePhases.find((item) => item.id === phase.id) || phase;
            const isLinked = phase.linkedToPrevious === true;
            return (
              <div key={phase.id} className={`phase-card ${phase.id === activePhase?.id ? "active" : ""}`}>
                <div className="phase-head">
                  <div className="phase-title">{phase.name}</div>
                  <div className="btns" style={{ marginTop: 0 }}>
                    <button type="button" className="mini ghost" onClick={() => { setActivePhaseId(phase.id); setVisibleMonth(startOfMonth(fromIso(effectivePhase.displayCommencement || effectivePhase.commencement))); }}>Select</button>
                    <button type="button" className="mini ghost" onClick={() => duplicatePhase(phase)}>Duplicate</button>
                    {phases.length > 1 && <button type="button" className="mini danger" onClick={() => removePhase(phase.id)}>Remove</button>}
                  </div>
                </div>
                <label>Phase / Section name</label>
                <input type="text" value={phase.name} onChange={(event) => setPhase(phase.id, { name: event.target.value })} />
                <label>Commencement date</label>
                {phases.indexOf(phase) > 0 && (
                  <label className="inline-check">
                    <input
                      type="checkbox"
                      checked={isLinked}
                      onChange={(event) => setPhase(phase.id, { linkedToPrevious: event.target.checked })}
                    />
                    <span>Link start to previous phase due date + 1 day</span>
                  </label>
                )}
                <input
                  type="date"
                  value={isLinked ? effectivePhase.displayCommencement : phase.commencement}
                  disabled={isLinked}
                  onChange={(event) => {
                    setPhase(phase.id, { commencement: event.target.value });
                    if (phase.id === activePhase?.id) setVisibleMonth(startOfMonth(fromIso(event.target.value)));
                  }}
                />
                <div className="row">
                  <div>
                    <label>Time for completion</label>
                    <input type="number" min="1" value={phase.duration} onChange={(event) => setPhase(phase.id, { duration: Math.max(1, Number(event.target.value || 1)) })} />
                  </div>
                  <div>
                    <label>Unit</label>
                    <select value={phase.durationType} onChange={(event) => setPhase(phase.id, { durationType: event.target.value })}>
                      <option value="weeks">Weeks - include non-working days, exclude special days</option>
                      <option value="months">Months - include non-working days, exclude special days</option>
                      <option value="workingWeeks">Working weeks</option>
                      <option value="workingDays">Working days</option>
                      <option value="calendarDays">Calendar days, excluding special non-working days</option>
                    </select>
                  </div>
                </div>
                <label>Working weekdays for this phase</label>
                <div className="weekday-grid">
                  {dayNames.map((name, index) => (
                    <label key={name} className={phase.weekdays[index] ? "checked" : ""}>
                      <input type="checkbox" checked={phase.weekdays[index]} onChange={(event) => toggleWeekday(phase.id, index, event.target.checked)} />
                      {name}
                    </label>
                  ))}
                </div>
                <div className="phase-result">
                  <div><small>Due completion</small><strong>{result ? resultLabel(result.due) : "-"}</strong></div>
                  <div><small>Excluded days</small><strong>{result ? result.excluded : "-"}</strong></div>
                </div>
              </div>
            );
          })}
          <div className="notes">
            <strong>GCC use note:</strong><br />
            Use each phase for the overall contract, sectional completions, key portions, or phased access dates. Final dates should still be checked against the signed Contract Data, Engineer's determinations, approved EOTs, and any contractual definition of non-working days.
          </div>
        </section>

        <section className="gcc-card">
          <div className="summary">
            <div className="metric"><small>Active phase</small><strong>{activePhase?.name || "-"}</strong></div>
            <div className="metric"><small>Required count</small><strong>{activeResult ? `${activeResult.required} ${activeResult.mode === "calendarDays" ? "counted calendar days" : "working days"}` : "-"}</strong></div>
            <div className="metric"><small>Due completion date</small><strong>{activeResult ? resultLabel(activeResult.due) : "-"}</strong></div>
            <div className="metric"><small>Calendar span</small><strong>{activeResult ? `${activeResult.span} days` : "-"}</strong></div>
            <div className="metric"><small>Excluded days</small><strong>{activeResult ? activeResult.excluded : "-"}</strong></div>
          </div>
          <div className="calendar-head">
            <button type="button" className="ghost" onClick={() => setVisibleMonth(new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1))}>Previous</button>
            <div className="month-title">{monthFmt.format(visibleMonth)}</div>
            <button type="button" className="ghost" onClick={() => setVisibleMonth(new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1))}>Next</button>
          </div>
          <div className="calendar">
            {dayNames.map((name) => <div key={name} className="dow">{name}</div>)}
            {renderCalendarDays()}
          </div>
          <div className="legend">
            <span><i className="swatch" style={{ background: "var(--work)" }} /> Working</span>
            <span><i className="swatch" style={{ background: "var(--non)" }} /> Non-working</span>
            <span><i className="swatch" style={{ background: "#ffedd5" }} /> Builders' break</span>
            <span><i className="swatch" style={{ background: "var(--holiday)" }} /> Public holiday</span>
            <span><i className="swatch" style={{ background: "#dbeafe" }} /> Counted for active phase</span>
            <span><i className="swatch" style={{ background: "#dcfce7" }} /> Due date outline</span>
          </div>

          <h3>Phase summary</h3>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Phase</th><th>Commencement</th><th>Duration</th><th>Due completion</th><th>Calendar span</th><th>Excluded</th></tr></thead>
              <tbody>
                {effectivePhases.map((phase) => {
                  const result = phaseResults[phase.id];
                  const storedPhase = phases.find((item) => item.id === phase.id) || phase;
                  return (
                    <tr key={phase.id}>
                      <td>
                        <strong>{phase.name}</strong>
                        {phase.id === activePhase?.id && <span className="tag phase-chip">active</span>}
                        {storedPhase.linkedToPrevious && <span className="tag">linked</span>}
                      </td>
                      <td>{dateFmt.format(fromIso(phase.displayCommencement || phase.commencement))}</td>
                      <td>{durationLabel(phase)}</td>
                      <td>{result ? resultLabel(result.due) : "-"}</td>
                      <td>{result ? `${result.span} days` : "-"}</td>
                      <td>{result ? result.excluded : "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <h3>Active phase counted-day register</h3>
          <div className="table-wrap">
            <table>
              <thead><tr><th>#</th><th>Date</th><th>Day</th><th>Status</th></tr></thead>
              <tbody>
                {activeResult?.counted?.length ? (
                  activeResult.counted.map((row, index) => (
                    <tr key={`${iso(row.date)}-${index}`}>
                      <td>{index + 1}</td>
                      <td>{dateFmt.format(row.date)}</td>
                      <td>{longDayNames[row.date.getDay()]}</td>
                      <td>{row.status.label}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="4" className="muted">The counted-day register will appear after calculation.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}

export default memo(GccDueCompletionPhasedSection);
